(function () {

    'use strict';

    angular.module('FotocApp')

    .component('imagesSearch', {
   
        templateUrl: (USE_TEMPLATE_CACHE ? '' :  window.BASE_PATH  + '../../src/') + 'editor/tools/imagesSearch.component.html',
        bindings: {},
        controller: ['$scope', '$editorService','$canvasService', '$http', 'CONSTANTS', '$q', '$timeout','$lang', '$shutterstock', function ($scope, $editorService, $canvasService, $http, CONSTANTS, $q, $timeout, $lang, $shutterstock) {
 
            var self = this;
            this.list = [];
           
            this.$editorService = $editorService;
            this.$shutterstock = $shutterstock;
            this.isLoading = false;
            this.noResult = false;
            $scope.$lang = $lang;
            
       
            this.$onInit = function () {   
               
                $scope.$watch('$ctrl.txt_search', function(){

                    self.list = [];
                    $shutterstock.onWatchTxt(self.list, self.txt_search)
                })
            
            }

            this.close = function ($event){

                $event.stopPropagation();
                $editorService.ui.imageSearchIsOpen = false
                $editorService.ui.toolOpen = 'images'  
                setTimeout(function (){
                   
                    document.getElementById('search-txt').blur();
                    
                }, 300);
               
            }

     


            this.selectImage = function($item){

                $timeout(function(){


                    var extract_url =  $editorService.extract_preview_url($item.assets.preview.url, $item.assets.preview.width, $item.assets.preview.height);
                    $editorService.data.images[$editorService.ui.editingItem] = {
                        type:'stock', 
                        data: $item, 
                        urlWithoutFilter:
                         extract_url, 
                         position:{}
                    }
                    $canvasService.setImage(extract_url)
                    $editorService.setCacheImages($item.assets.large_thumb.url);
                    $editorService.ui.imageSearchIsOpen = false;
                    $editorService.ui.toolOpen = 'transform';    
                    $timeout(function(){
                        $editorService.ui.images = self.list;
                        document.getElementById('search-txt').blur();
                    }, 300);



                }, 300);
            }

          

        }]
        
        
    })

})();